export const registerEventsConfig = {
    parentSelector: '.customer.register', // Scope events to the register form section
    events: {
        // Register | focus in text field (CSV Line 199)
        registerFocus: {
            selector: '#RegisterForm-FirstName, #RegisterForm-LastName, #RegisterForm-email, #RegisterForm-password',
            event: {
                event: 'register', // Event name from CSV
                component: 'register', // Component name from CSV
                element: 'text_field',
                action: 'focus',
                trigger: 'focus',
                getDynamicData: (element) => {
                    // Find the associated label for the field name
                    const label = document.querySelector(`label[for="${element.id}"]`);
                    // Derive field name from label or ID
                    let fieldName = 'Unknown';
                    if (label) {
                        fieldName = label.textContent.trim();
                    } else {
                        // Fallback based on ID pattern
                        if (element.id.includes('FirstName')) fieldName = 'Voornaam';
                        else if (element.id.includes('LastName')) fieldName = 'Achternaam';
                        else if (element.id.includes('email')) fieldName = 'E-mail';
                        else if (element.id.includes('password')) fieldName = 'Wachtwoord';
                    }
                    return {
                        field_name: fieldName
                    };
                }
            }
        },

        // Register | input in text_field (CSV Line 200)
        registerInput: {
            selector: '#RegisterForm-FirstName, #RegisterForm-LastName, #RegisterForm-email, #RegisterForm-password',
            event: {
                event: 'register',
                component: 'register',
                element: 'text_field',
                action: 'input',
                trigger: 'input', // Debounced by datalayer.js
                getDynamicData: (element) => {
                    const label = document.querySelector(`label[for="${element.id}"]`);
                    let fieldName = 'Unknown';
                    if (label) {
                        fieldName = label.textContent.trim();
                    } else {
                        if (element.id.includes('FirstName')) fieldName = 'Voornaam';
                        else if (element.id.includes('LastName')) fieldName = 'Achternaam';
                        else if (element.id.includes('email')) fieldName = 'E-mail';
                        else if (element.id.includes('password')) fieldName = 'Wachtwoord';
                    }
                    // Don't capture password value for security
                    return {
                        field_name: fieldName,
                        // Only include input_value for non-password fields if needed
                        input_value: element.type !== 'password' ? element.value : undefined
                    };
                }
            }
        },

        // Register | click on cta-button (CSV Line 202)
        registerSubmitClick: {
            selector: '#create_customer button', // Target the submit button
            event: {
                event: 'register',
                component: 'register',
                element: 'cta_button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    // Get button text from its span or directly
                    const buttonText = element.querySelector('span')?.textContent.trim() || element.textContent.trim();
                    return {
                        click_text: buttonText
                    };
                }
            }
        },

        // Register | click on text link (CSV Line 204)
        registerLoginLinkClick: {
            selector: '#create_customer a[href="/account/login"]', // Target the specific 'Back to login' link
            event: {
                event: 'register',
                component: 'register',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => { // element is the <a> tag
                    return {
                        link_text: element.textContent.trim(),
                        link_url: element.getAttribute('href') // Get href attribute value
                    };
                }
            }
        }
    }
}; 